// extracted by mini-css-extract-plugin
module.exports = {"container":"container__g3N8w","collapsed":"collapsed__Coast"};